import type { FC } from 'react';
import { Controller } from 'react-hook-form';
import { generateFieldClassNames } from '@/DesignSystem/Helper';
import type { IFieldProps, IFieldRadio } from '@/DesignSystem/Model/DataModel';
interface IGroupRadioFieldProps extends IFieldProps<IFieldRadio['value']> {
  items?: IFieldRadio[];
}
const GroupRadioField: FC<IGroupRadioFieldProps> = props => {
  const {
    control,
    name,
    defaultValue,
    items,
    prefix,
    suffix,
    label
  } = props;
  return <Controller name={name} control={control} defaultValue={defaultValue ?? ''} render={({
    field,
    fieldState
  }) => {
    const error = fieldState.error?.message || '';
    const hasValue = !!items?.find(item => String(item.value) === String(field.value));
    return <>
            <div className={generateFieldClassNames({
        ...props,
        fieldType: 'groupRadio',
        hasError: !!error,
        hasValue
      })}>
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <div className="ui__field__content">
                {label && <div className="ui__field__label">{label}</div>}
                {prefix && <div className="ui__field__prefix">{prefix}</div>}

                <div className="ui__field__content__radio__items">
                  {items?.map(item =>
            // eslint-disable-next-line jsx-a11y/label-has-associated-control
            <label className="ui__field__content__radio__items__item" key={item.value}>
                      <input type="radio" value={String(item.value)} name={name} checked={String(item.value) === String(field.value)} onChange={field.onChange} />
                      <span className="ui__field__content__radio__items__item__title">{item.label}</span>
                    </label>)}
                </div>

                {suffix && <div className="ui__field__suffix">{suffix}</div>}
              </div>
            </div>
            {error && <div className="ui__field__error">{error}</div>}
          </>;
  }} data-sentry-element="Controller" data-sentry-component="GroupRadioField" data-sentry-source-file="GroupRadioField.tsx" />;
};
GroupRadioField.defaultProps = {
  size: 'middle'
};
export default GroupRadioField;